import { Component }                                from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { LoadingController }                        from 'ionic-angular';
import { BookingDetailsViewModel }                  from './xv-booking-details';
import { dmBooking }                                from './xv-bookings';
import { MLText }                                   from '../../services/MLText';
import { dmLoading }                                from '../loading/loading';

@Component({
     selector:    'page-booking-details'
    ,templateUrl: 'booking-details.html'
})
export class BookingDetailsPage {
    NewLoading: (pMessage: string) => dmLoading;
    Dismiss:    ()                 => void;

    BookingDetails: BookingDetailsViewModel;

    constructor(
         public navCtrl:     NavController
        ,public navParams:   NavParams
        ,public loadingCtrl: LoadingController
        ,public viewCtrl:    ViewController
        ,public mlText:      MLText
    ) {
        let booking: dmBooking = this.navParams.get('booking') as dmBooking;

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.Dismiss = () => { this.viewCtrl.dismiss(); }

        this.BookingDetails = new BookingDetailsViewModel(
             mlText
            ,booking
            ,this.NewLoading
            ,this.Dismiss
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/bookings/booking-details.ts